










import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  @Prop({ type: String, default: "" }) private returnTitle;
  @Prop({ type: String, default: "" }) private titleName;
  @Prop({ type: String, default: "" }) private returnPath;
  public toPath() {
    if (this.$route.path != this.returnPath && this.returnPath) {
      if (this.$route.query.isTrue) {
        this.$router.push({
          path: this.returnPath,
          query: this.$route.query,
        });
      } else {
        this.$router.push(this.returnPath);
      }
    }
  }
}
